import { Link } from "react-router-dom";

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-16 md:mt-24 bg-primary-950 border-t border-primary-900/60">
      <div className="px-4 md:px-10 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center text-background-50">
                <i className="ri-fire-fill text-lg" />
              </span>
              <span className="font-heading font-bold text-lg text-foreground-50">热情的邻居</span>
            </div>
            <p className="text-sm text-foreground-400 leading-relaxed max-w-sm">
              提供最新影视剧集信息、剧情介绍及相关影视内容，帮助影视爱好者全面了解与追踪感兴趣的影视作品。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-100 mb-4">快速导航</h4>
            <div className="flex flex-col gap-3">
              <Link to="/" className="text-sm text-foreground-400 hover:text-accent-500 w-fit transition-colors">首页</Link>
              <Link to="/category" className="text-sm text-foreground-400 hover:text-accent-500 w-fit transition-colors">影视分类</Link>
              <Link to="/search" className="text-sm text-foreground-400 hover:text-accent-500 w-fit transition-colors">搜索</Link>
              <Link to="/about" className="text-sm text-foreground-400 hover:text-accent-500 w-fit transition-colors">关于我们</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-100 mb-4">联系我们</h4>
            <p className="text-sm text-foreground-400 leading-relaxed">
              反馈邮箱：hello@hotneighbor.example
            </p>
            <p className="text-sm text-foreground-400 leading-relaxed mt-2">
              每周一至周五 09:00 - 18:00
            </p>
            <div className="flex items-center gap-3 mt-4">
              <span className="w-9 h-9 rounded-full bg-primary-800/70 flex items-center justify-center text-foreground-300">
                <i className="ri-wechat-line" />
              </span>
              <span className="w-9 h-9 rounded-full bg-primary-800/70 flex items-center justify-center text-foreground-300">
                <i className="ri-weibo-line" />
              </span>
              <span className="w-9 h-9 rounded-full bg-primary-800/70 flex items-center justify-center text-foreground-300">
                <i className="ri-mail-line" />
              </span>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-primary-900/70 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            © {year} 热情的邻居 · 站点内容均为示例演示，不提供真实播放与下载服务
          </p>
          <p className="text-xs text-foreground-500">影视信息内容展示平台</p>
        </div>
      </div>
    </footer>
  );
}